import { gql } from "@apollo/client";

export const GET_PROPERTIES_FOR_MANUAL_CONTRACT = gql`
  query getPropertiesForManualContract {
    properties(includeArchived: false) {
      id
      name
      units
      phone
      email
      organization {
        id
        name
      }
      address {
        address1
        address2
        city
        state
        zip
      }
    }
  }
`;

export const GET_TEAM_FOR_MANUAL_CONTRACT = gql`
  query getTeamForManualContract($id: ID!) {
    organization(id: $id) {
      id
      team {
        id
        fullName
        email
        isArchived
      }
    }
  }
`;

export const GET_ORGANIZATIONS_FOR_MANUAL_CONTRACT = gql`
  query getOrganizationsForManualContract {
    organizations {
      id
      name
    }
  }
`;

export const GET_SUBSCRIPTIONS_FOR_MANUAL_CONTRACT = gql`
  query getSubscriptionsForManualContract($propertyId: ID!) {
    subscriptionsForProperty(propertyId: $propertyId) {
      id
      startDate
      endDate
      invoicedId
      plan {
        id
        name
      }
      propertyInterestList {
        id
        interestList {
          id
          name
        }
      }
    }
  }
`;

export const GET_MANUAL_CONTRACT = gql`
  query getManualContract($id: ID!) {
    propertyContract(id: $id) {
      id
      manuallyEntered
      propertyId
      planId
      unitCount
      signedAt
      billingFrequency
      contractStartDate
      initialTermEndDate
      propertyLegalName
      status
      signerEmail
      propertyPhone
      propertyEmail
      propertyAddress
      hasPdf
      subscription {
        id
        startDate
        endDate
        invoicedId
        plan {
          id
          name
        }
      }
    }
  }
`;

export const CREATE_MANUAL_PROPERTY_CONTRACT = gql`
  mutation createManualPropertyContract($input: ManualPropertyContractInput!) {
    createManualPropertyContract(input: $input) {
      id
    }
  }
`;

export const UPDATE_MANUAL_PROPERTY_CONTRACT = gql`
  mutation updateManualPropertyContract($id: ID!, $input: ManualPropertyContractInput!) {
    updateManualPropertyContract(id: $id, input: $input) {
      id
    }
  }
`;
